import ResizeObserver from "resize-observer-polyfill";

// Needed by Virtuoso
// https://github.com/petyosi/react-virtuoso#browser-support
if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

// Object.hasOwn polyfill for older browsers
// Used by react-router-dom v6.30+
if (!(Object as any).hasOwn) {
  (Object as any).hasOwn = function (obj: object, prop: PropertyKey): boolean {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}
